import { useLazyUserLogin } from '@gef-ui/authorization-v2';
import { getHelpdeskErrorObject } from '@gef-ui/error-report-core/utils';
import { useState } from 'react';
import useSendErrorBase from '../useSendErrorBase';
const useSendErrorLocal = (sendErrorCallback)=>{
    const [isSent, setIsSent] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const sendErrorBase = useSendErrorBase(sendErrorCallback);
    const getUser = useLazyUserLogin();
    const sendErrorLocal = async (fe, be, error, timestamp)=>{
        const body = getHelpdeskErrorObject(fe, be, error, getUser(), timestamp);
        const handleCaughtError = ()=>setIsError(true);
        setIsSending(true);
        try {
            const response = await sendErrorBase(body);
            if (!response.ok) {
                handleCaughtError();
            }
        } catch (_e) {
            handleCaughtError();
        } finally{
            setIsSent(true);
            setIsSending(false);
        }
    };
    return {
        sendErrorLocal,
        isError,
        isSent,
        isSending
    };
};
export default useSendErrorLocal;
